/**
 * Custom Price Formatter
 *
 * Splits price text into structured spans for independent styling of
 * currency symbol, integer part, and decimal part.
 * Scoped to the product-information section's product-price block.
 */

const SCOPE = '.product-information product-price';
const PRICE_SELECTOR = `${SCOPE} .price, ${SCOPE} .compare-at-price`;

let isFormatting = false;

/**
 * @param {string} text - Raw price string (e.g. "€1.299,99")
 * @returns {string|null} HTML with price parts wrapped in spans
 */
const formatSinglePrice = (text) => {
  const match = text.match(/^(.*?)(\d[\d.,]*)([.,])(\d{2})(\s*[^\d]*)$/);
  if (!match) return null;

  const [, currency, integer, sep, decimals, suffix] = match;
  let html = '';

  if (currency.trim()) {
    html += `<span class="custom-price__currency">${currency}</span>`;
  }

  html += `<span class="custom-price__integer">${integer}${sep}</span>`;
  html += `<span class="custom-price__decimals">${decimals}</span>`;

  if (suffix.trim()) {
    html += `<span class="custom-price__suffix">${suffix}</span>`;
  }

  return html;
};

/** @param {HTMLElement} el */
const formatPriceNode = (el) => {
  if (el.querySelector('.custom-price__integer')) return;

  const text = el.textContent.trim();
  if (!text) return;

  if (text.includes(' - ')) {
    const parts = text.split(' - ');
    const formatted = parts.map((p) => formatSinglePrice(p.trim())).filter(Boolean);

    if (formatted.length === parts.length) {
      el.innerHTML = formatted.join('<span class="custom-price__range-sep"> – </span>');
    }
    return;
  }

  const html = formatSinglePrice(text);
  if (html) el.innerHTML = html;
};

const formatAll = () => {
  if (isFormatting) return;
  isFormatting = true;

  for (const el of document.querySelectorAll(PRICE_SELECTOR)) {
    formatPriceNode(el);
  }

  isFormatting = false;
};

formatAll();

const root = document.querySelector(SCOPE);

if (root) {
  const observer = new MutationObserver(() => formatAll());
  observer.observe(root, { childList: true, subtree: true, characterData: true });
}
